import { GroupedTable } from "@/components/GroupedTable/GroupedTable";
import { Page, PageBody, PageHeader } from "@/components/app-layout";
import { AppTopRightMenu } from "@/components/app-layout/AppTopRightMenu";
import { CreateOrganizationModal } from "@/components/organization/CreateOrganizationModal";
import { Button } from "@/components/ui/button";
import { TableSkeleton } from "@/components/ui/skeleton";
import { useOrganizationsData } from "@/data/use-organizations-data";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlus } from "@nnr/fontawesome-sharp-light/icons/sharp/light";
import { useState } from "react";

export default function GlobalAdminOrganizationsPage() {
  const [isCreating, setIsCreating] = useState(false);

  return (
    <>
      <AppTopRightMenu.ContentPortal display="append">
        <Button onClick={() => setIsCreating(true)}>
          <FontAwesomeIcon icon={faPlus} />
          Create Organization
        </Button>
      </AppTopRightMenu.ContentPortal>

      <Page>
        <PageHeader>
          <PageHeader.Title>Organizations</PageHeader.Title>
        </PageHeader>
        <PageBody>
          <Contents />
        </PageBody>
      </Page>

      <CreateOrganizationModal open={isCreating} onOpenChange={setIsCreating} />
    </>
  );
}

function Contents() {
  const { organizations, isLoading } = useOrganizationsData();

  if (isLoading) {
    return <TableSkeleton />;
  }

  return (
    <GroupedTable
      isSearchable
      searchableFields={["name", "slug"]}
      data={[
        {
          groupId: "organizations",
          label: "Organizations",
          items: organizations,
        },
      ]}
      columns={[
        { key: "name", label: "Name" },
        { key: "slug", label: "Slug" },
      ]}
      rowLink={(row) => ({
        to: `/admin/organizations/$organizationUuid`,
        params: { organizationUuid: row.uuid },
      })}
    />
  );
}
